// imports
import "./Partners.css";
import { partnersData } from "../../../Data/WhoWeAreData/PartnersData";

// main
export default function PartnersSection() {
  return (
    <div className="partners-container">
      <div className="partners-header-title">
        Our Partners
      </div>
      
      <div className="partners-grid">
        {partnersData && partnersData.length > 0 && 
          partnersData.map((partner, index) => (
            partner.website ? (
              <a 
                href={partner.website} 
                target="_blank" 
                rel="noopener noreferrer"
                className="partner-card partner-card-link"
                key={index}
              >
                <div className="partner-logo-container">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="partner-logo"
                  />
                </div>
                <div className="partner-name-container">
                  <div className="partner-name-link">
                    {partner.name}
                  </div>
                </div>
              </a>
            ) : (
              <div className="partner-card" key={index}>
                <div className="partner-logo-container">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="partner-logo"
                  />
                </div>
                <div className="partner-name-container">
                  <div className="partner-name-link">
                    {partner.name}
                  </div>
                </div>
              </div>
            )
          ))
        }
      </div>
    </div>
  );
}
